import React, { FC, useState } from "react";
import MainLayout from "../../Layouts/MainLayout";
import SelectDropdown from "../atoms/SelectDropdown";
import Button from "../atoms/Button";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomTable from "../atoms/CustomTable";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import Modalpopup from "../atoms/Modalpopup";
//logs
const Logs: FC = () => {
  const [models, setModels] = useState("");
  const navigate = useNavigate();
  const [showUser, setShowUser] = useState(false);
  const [showEmploye, setShowEmploye] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const { crewName } = location.state || {};
  const modelOptions = [{ name: "Agent", value: "Agent" }];
  const columns = [
    "User",
    "Object",
    "Action",
    "Model",
    "Object ID",
    "Action time",
  ];

  const rows = [
    {
      user: "Admin",
      object: "Email Crew",
      action: "Addition",
      model: "Task",
      objectId: "57",
      actionTime: "Fri 20 Dec 2024 09:46",
    },
    {
      user: "Manager",
      object: "Project File",
      action: "Update",
      model: "Document",
      objectId: "12",
      actionTime: "Tue 02 Jan 2025 11:15",
    },
    {
      user: "User1",
      object: "Timesheet",
      action: "Deletion",
      model: "Entry",
      objectId: "103",
      actionTime: "Mon 18 Mar 2025 14:23",
    },
  ];

  const users = ["Admin", "Manager", "User1"];

  const modal = ["Task", "Document", "Entry", "Log", "Note"];

  const action = ["Addition", "Update", "Deletion", "View", "Export"];

  const date = [
    "Fri 20 Dec 2024 09:46",
    "Tue 02 Jan 2025 11:15",
    "Mon 18 Mar 2025 14:23",
    "Wed 05 Apr 2025 10:00",
    "Thu 27 Mar 2025 16:30",
  ];

  const actionButtons = [
    {
      alt: "Logs",
      className: "btn SaveBtn",
      onClick: (rowIndex: number) => {
        navigate(`/logs_details/${id}`);
      },
    },
  ];


  // const [showPopup, setShowPopup] = useState(false);
  // const handleFilterClick = () => {
  //   setShowPopup(!showPopup);
  // };


  const [openPopup, setShowPopup] = useState(false);

  const handleOpen = () => {
    setShowPopup(true);
  }
  const handleClosePopup = () => {
    setShowPopup(false);
  }



  // let A = 10;
  // console.log(A);
  const bodyContent = () => {
    return (
      <>
        <div className="bg-header-row py-2">
          <div className="d-flex flex-wrap  ms-2">
            <div className="me-5">
              <label>
                <input
                  type="checkbox"
                  className="me-2"
                  checked={showUser}
                  onChange={() => setShowUser(!showUser)}
                />
                Users
              </label>
            </div>
            <div className="me-5">
              <label>
                <input
                  type="checkbox"
                  checked={showEmploye}
                  className="me-2"
                  onChange={() => setShowEmploye(!showEmploye)}
                />
                modal
              </label>
            </div>
            <div className="me-5">
              <label>
                <input
                  type="checkbox"
                  className="me-2"
                  checked={showProject}
                  onChange={() => setShowProject(!showProject)}
                />
                action
              </label>
            </div>
            <div>
              <label>
                <input
                  type="checkbox"
                  className="me-2"
                  checked={showProject}
                  onChange={() => setShowProject(!showProject)}
                />
                date
              </label>
            </div>
          </div>
        </div>

        {(showUser || showEmploye || showProject) && (
          <div className="border rounded p-3 px-2 d">

            {/* Users (Horizontal row) */}
            {showUser && users.length > 0 && (
              <div>
                <strong className="mb-2 d-block">Users</strong>
                <div className="d-flex flex-wrap">
                  {users.map((user) => (
                    <label key={user} className="me-3 mb-2">
                      <input type="checkbox" value={user} className="me-1" />
                      {user}
                    </label>
                  ))}
                </div>
              </div>
            )}

            {/* Modal (Horizontal row) */}
            {showEmploye && modal.length > 0 && (
              <div>
                <strong className="mb-2 d-block">Modal</strong>
                <div className="d-flex flex-wrap">
                  {modal.map((modals) => (
                    <label key={modals} className="me-3 mb-2">
                      <input type="checkbox" value={modals} className="me-1" />
                      {modals}
                    </label>
                  ))}
                </div>
              </div>
            )}

            {/* Action (Horizontal row) */}
            {showProject && action.length > 0 && (
              <div>
                <strong className="mb-2 d-block">Action</strong>
                <div className="d-flex flex-wrap">
                  {action.map((actions) => (
                    <label key={actions} className="me-3 mb-2">
                      <input type="checkbox" value={actions} className="me-1" />
                      {actions}
                    </label>
                  ))}
                </div>
              </div>
            )}

            {/* Date (Horizontal row) */}
            {showProject && date.length > 0 && (
              <div>
                <strong className="mb-2 d-block">Date</strong>
                <div className="d-flex flex-wrap">
                  {date.map((dateItem) => (
                    <label key={dateItem} className="me-3 mb-2">
                      <input type="checkbox" value={dateItem} className="me-1" />
                      {dateItem}
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}



      </>
    )
  }

  return (
    <MainLayout>
      <SectionHeader back={true} filter={handleOpen} title={`Logs`} ></SectionHeader>
      {openPopup && (
        <div>
          <Modalpopup
            title="Logs"
            body={
              bodyContent()
            }
            handleClosePopup={handleClosePopup}
          />
        </div>
      )}
      <WindowHeightComponent className={""}>
        <CustomTable
          columns={columns}
          rows={rows}
          actionButtons={actionButtons}
        />
      </WindowHeightComponent>
    </MainLayout>
  );
};

export default Logs;
